import React from "react";
import RegisterStyles from "./Register.module.css";
import DisclaimerFooter from "../DisclaimerFooter/DisclamerFooter";
import Logo from "../../assets/Logo.svg";
import { Input, Icon, Button, Form } from "antd";

interface LoginProps {
  form: {
    getFieldsError: Function;
    getFieldDecorator: Function;
    validateFields: Function;
  };
  emailAddress: string;
  registerUser: Function;
}

type RegisterValues = {
  siteId: string;
  email: string;
};

function hasErrors(fieldsError: any) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const Register: React.FC<LoginProps> = ({
  form: { getFieldsError, getFieldDecorator, validateFields },
  registerUser,
  emailAddress
}) => {
  const handleSubmit = (e: any) => {
    e.preventDefault();
    validateFields((err: Object, values: RegisterValues) => {
      if (!err) {
        registerUser({ email: values.email, siteID: values.siteId });
      }
    });
  };

  const validateSideId = (
    rule: string,
    value: string,
    callback: Function
  ): void => {
    if (/\bM02-[A-Za-z]{2}1[0-9]{4}\b/g.test(value)) {
      callback();
    } else {
      callback("Please enter a correctly formatted site ID.");
    }
  };

  return (
    <div className={RegisterStyles.HomeContainer}>
      <DisclaimerFooter className={RegisterStyles.disclaimer} />
      <img src={Logo} className={RegisterStyles.logo} alt="Sibel Logo" />
      <Form onSubmit={handleSubmit} className={RegisterStyles.form}>
        <Form.Item className={RegisterStyles.fieldItem}>
          {getFieldDecorator("email", {
            rules: [{ required: true, message: "Please input an email" }]
          })(
            <Input
              name="email"
              placeholder="EMAIL"
              type="email"
              className={RegisterStyles.input}
              prefix={<Icon type="mail" className={RegisterStyles.icon} />}
            />
          )}
        </Form.Item>
        <Form.Item className={RegisterStyles.fieldItem}>
          {getFieldDecorator("siteId", {
            rules: [
              {
                required: true,
                validator: validateSideId
              }
            ]
          })(
            <Input
              name="siteId"
              placeholder="CLINICAL SITE ID (M02-XXXXXXX)"
              className={RegisterStyles.input}
              prefix={
                <Icon type="environment" className={RegisterStyles.icon} />
              }
            />
          )}
        </Form.Item>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className={RegisterStyles.loginButton}
          disabled={hasErrors(getFieldsError())}
        >
          Register
        </Button>
      </Form>
    </div>
  );
};

export default Form.create({ name: "RegisterForm" })(Register);
